import React, { createContext, useContext, useState, ReactNode } from "react";

interface DocumentContextType {
  refreshSidebar: () => void;
  sidebarRefreshTrigger: number;
}

const DocumentContext = createContext<DocumentContextType | undefined>(
  undefined
);

export const DocumentProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [sidebarRefreshTrigger, setSidebarRefreshTrigger] = useState(0);

  const refreshSidebar = () => {
    setSidebarRefreshTrigger((prev) => prev + 1);
  };

  return (
    <DocumentContext.Provider value={{ refreshSidebar, sidebarRefreshTrigger }}>
      {children}
    </DocumentContext.Provider>
  );
};

export const useDocumentContext = () => {
  const context = useContext(DocumentContext);
  if (context === undefined) {
    throw new Error(
      "useDocumentContext must be used within a DocumentProvider"
    );
  }
  return context;
};
